import dayjs from 'dayjs';
import React, { useCallback, useMemo } from 'react';
import { createIcon } from '@download/blockies';

import { useAppSelector } from 'store/hooks';
import { addressFormat } from 'lib/nicknameFormat';

interface IProjectDetailsProps {}

const ProjectDetails: React.FC<IProjectDetailsProps> = ({}) => {
  const { raffleInfo } = useAppSelector((state) => state.raffleDetails);

  const avatar = useCallback(() => {
    if (
      !!raffleInfo?.owner?.discord_avatar &&
      !!raffleInfo?.owner?.discord_username
    ) {
      return raffleInfo?.owner?.discord_avatar;
    } else if (
      !!raffleInfo?.owner?.twitter_avatar &&
      !!raffleInfo?.owner?.twitter_username
    ) {
      return raffleInfo?.owner?.twitter_avatar;
    } else if (!!raffleInfo?.owner?.address) {
      const src = createIcon({
        seed: raffleInfo?.owner?.address,
        size: 10,
        scale: 8,
      }).toDataURL();
      return src;
    }
  }, [raffleInfo?.owner]);

  const name = useCallback(() => {
    if (
      !!raffleInfo?.owner?.discord_avatar &&
      !!raffleInfo?.owner?.discord_username
    ) {
      return raffleInfo?.owner?.discord_username;
    } else if (
      !!raffleInfo?.owner?.twitter_avatar &&
      !!raffleInfo?.owner?.twitter_username
    ) {
      return raffleInfo?.owner?.twitter_username;
    } else {
      return addressFormat(raffleInfo?.owner?.address);
    }
  }, [raffleInfo?.owner]);

  const createTime = useMemo(() => {
    return dayjs
      .unix((raffleInfo?.create_time as number) / 1000)
      .format('MM/DD/YYYY');
  }, [raffleInfo?.create_time]);

  const textRender = useCallback(() => {
    return (
      <div>
        {(raffleInfo?.description as string)
          .split(/(\s+|\n)/)
          .map((word: string, index: number) => {
            if (word.startsWith('http://') || word.startsWith('https://')) {
              return (
                <a
                  key={index}
                  href={word}
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary-500 underline"
                >
                  {word}
                </a>
              );
            } else {
              return word ;
            }
          })}
      </div>
    );
  }, [raffleInfo?.description]);

  return (
    <div className=" mt-8">
      <div className="mb-4 text-2xl font-semibold text-neutral-100">
        Raffle Description
      </div>

      <div className="text-sm font-normal text-neutral-300">
        <div>
          <style jsx>{`
            div :global(figure) {
              position: relative;
            }
            div :global(iframe) {
              position: absolute;
            }
          `}</style>
          <div className="whitespace-pre-wrap break-words">{textRender()}</div>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-1 break-all text-sm font-normal text-neutral-100">
        <span>Created by</span>
        <img src={avatar()} className="h-6 w-6 rounded-full" alt="" />
        <span className="font-medium underline ">{name()}</span>{' '}
        <span className="text-neutral-300">from</span>
        <span>{raffleInfo?.campaign?.name}</span>{' '}
        <span className="text-neutral-300">on</span>
        <span>{createTime}</span>
      </div>
    </div>
  );
};

export default ProjectDetails;
